import { FC, useMemo } from 'react'
import { FutureLayerUID, FutureLayer } from 'components/features/future/types'
import { FuturePanePreset } from 'components/features/future/FuturePanePreset/FuturePanePreset'
import * as yup from 'yup'
import { useLayerSelector, extendCommonSchema } from 'components/features/future/helpers'
import { FutureWhenInput } from 'components/features/future/FutureWhenInput/FutureWhenInput'
import { FutureFieldSlider } from 'components/features/future/FutureField/FutureFieldSlider'
import { maskNumberFromZero } from 'components/atoms/inputs/maskedInput'
import { schemaNumber } from 'schemas/baseSchema'
import { LAYER_METAS } from 'constants/future'
import { ObjectSchema } from 'yup'
import { useCollectLayerErrors } from 'components/features/future/hooks/useCollectErrors'
import { LayerStatus } from 'components/features/future/LayerStatus/LayerStatus'

const LAYER_SLUG = 'recession' as const
type LayerSlugType = typeof LAYER_SLUG
type LayerType = Extract<FutureLayer, { slug: LayerSlugType }>

const schemaCreator = extendCommonSchema<LayerSlugType>(yup.object({
  duration_months: schemaNumber,
}) as ObjectSchema<LayerType>)

type FutureLayerPaneRecessionProps = {
  uid?: FutureLayerUID
  onCancel: () => void
}

export const FutureLayerPaneRecession: FC<FutureLayerPaneRecessionProps> = (props) => {
  const { onCancel, uid } = props
  const layer = useLayerSelector<LayerSlugType>(props)

  const layerMeta = useMemo(() => LAYER_METAS[LAYER_SLUG], [])

  const layerWidthDefaults = useMemo(() => ({
    duration_months: 11,
    ...layer,
  } as typeof layer), [layer])

  return (
    <FuturePanePreset<LayerSlugType>
      layer={ layerWidthDefaults }
      slug={ LAYER_SLUG }
      name={ layerMeta.name }
      icon={ layerMeta.icon }
      type={ layerMeta.type }
      schemaCreator={ schemaCreator }
      onCancel={ onCancel }
    >
      <FormFields uid={ uid } />
    </FuturePanePreset>
  )
}

type FormFieldsProps = {
  uid?: FutureLayerUID
}
const FormFields: FC<FormFieldsProps> = (props) => {
  const { uid } = props

  const errors = useCollectLayerErrors<LayerType>()

  const completeChild = useMemo(() => (
    <h1>
      Event Completed
    </h1>
  ), [])

  return (
    <LayerStatus uid={ uid || null } completeContent={ completeChild } skipPartialState type='event'>
      <FutureWhenInput error={ errors.whenField } />

      <FutureFieldSlider
        label='Duration (months)'
        name='duration_months'
        mask={ maskNumberFromZero }

        error={ errors.duration_months }
        note='The average recession lasts about 11 months'

        min={ 1 }
        max={ 36 }
        step={ 1 }
      />

    </LayerStatus>
  )
}
